import { createSelector } from 'reselect'

export const sortedLoansSelector = createSelector(
  (data) => data.sort((a, b) => (a.SortID < b.SortID ? -1 : 1)),
  (result) => result,
)
